import { useMutation, useQueryClient } from 'react-query';
import { successToast } from 'lib/components/toasts/success';
import { useToastError } from 'lib/hooks';
import { EXPRESS_API } from 'configs/api/expressApi';
import { organizationVideoQueryKeys } from './queryKeys';
import { OrganizationVideo } from './useOrganizationVideoQuery';

const duplicateOrganizationVideo = async (id: number) => {
  return await EXPRESS_API.post(`/organization-videos/${id}/duplicate`);
};

interface IUseDuplicateOrganizationVideoMutation {
  onSuccessCallback?: (video: OrganizationVideo) => void;
}

export const useDuplicateOrganizationVideoMutation = ({
  onSuccessCallback,
}: IUseDuplicateOrganizationVideoMutation) => {
  const { showError } = useToastError();
  const queryClient = useQueryClient();

  return useMutation(duplicateOrganizationVideo, {
    onSuccess: res => {
      queryClient.invalidateQueries(organizationVideoQueryKeys.all);
      successToast({ title: 'Video has been duplicated!' });
      onSuccessCallback?.(res.data);
    },
    onError: error =>
      showError(
        error,
        'An error occurred while trying to duplicate the video!'
      ),
  });
};
